import {
  Button,
  GreyGrey70,
  IconPlus,
  IconCalendarDays,
  IconSignature,
  IconBuildings,
  SequenceMenu
} from '@sequencehq/core-components'
import { Dispatch, SetStateAction } from 'react'

import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { ProtectedSequenceMenuItem } from 'lib/rbac/ProtectedSequenceMenuItem'
import { useLogEvent } from 'lib/postHog/useLogEvent'

export const AddMenu = () => {
  const flags = useFeatureFlags()
  const { logEvent } = useLogEvent()

  const items = [
    ({ setIsOpen }: { setIsOpen?: Dispatch<SetStateAction<boolean>> }) => (
      <ProtectedSequenceMenuItem
        permission="org.billing:create"
        to="/billing-schedules/new?reset=true"
      >
        <SequenceMenu.Item
          key="new-schedule"
          uuid="new-schedule"
          label="New schedule"
          iconRight={<IconCalendarDays color="inherit" />}
          onClick={() => {
            logEvent({
              eventName: 'nav_manual_new_schedule'
            })
            setIsOpen?.(false)
          }}
          data-testid="header.addMenu.newSchedule"
        />
      </ProtectedSequenceMenuItem>
    ),
    !flags.showQuoteBuilder
      ? null
      : ({ setIsOpen }: { setIsOpen?: Dispatch<SetStateAction<boolean>> }) => (
          <ProtectedSequenceMenuItem
            permission={['org.quote:create', 'org.quote:content.update']}
            needsEveryPermission
            to="/quotes/new?reset=true"
          >
            <SequenceMenu.Item
              key="new-quote"
              uuid="new-quote"
              label="New quote"
              iconRight={<IconSignature color="inherit" />}
              onClick={() => {
                logEvent({
                  eventName: 'nav_manual_new_quote'
                })
                setIsOpen?.(false)
              }}
              data-testid="header.addMenu.newQuote"
            />
          </ProtectedSequenceMenuItem>
        ),
    ({ setIsOpen }: { setIsOpen?: Dispatch<SetStateAction<boolean>> }) => (
      <ProtectedSequenceMenuItem
        permission="org.customer:create"
        to="/customers/create"
      >
        <SequenceMenu.Item
          key="new-customer"
          uuid="new-customer"
          label="New customer"
          iconRight={<IconBuildings color="inherit" />}
          onClick={() => {
            logEvent({
              eventName: 'nav_manual_new_customer'
            })
            setIsOpen?.(false)
          }}
          data-testid="header.addMenu.newCustomer"
        />
      </ProtectedSequenceMenuItem>
    )
  ].filter(Boolean)

  return (
    <SequenceMenu
      width={180}
      data-testid="header.addMenu"
      menuButton={
        <Button
          size="28px"
          style={{ padding: '0', minWidth: 'initial', flexShrink: '0' }}
          variant="secondary"
          aria-label="Action"
          icon={<IconPlus color={GreyGrey70} />}
          data-testid="header.addMenu.button"
        />
      }
      items={items}
    />
  )
}
